// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZoQv","label":"styles_label__1jAjr"};